/**
 * Utilitaires pour le formatage des dates
 */

/**
 * Formate une date au format français complet
 * @param {string|Date} dateString - La date à formater
 * @param {object} options - Options de formatage
 * @returns {string} La date formatée
 */
export const formatDate = (dateString, options = {}) => {
  if (!dateString) return "";

  const defaultOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    ...options
  };

  return new Date(dateString).toLocaleDateString("fr-FR", defaultOptions);
};

/**
 * Formate une date au format court (JJ/MM/AAAA)
 * @param {string|Date} dateString - La date à formater
 * @returns {string} La date formatée
 */
export const formatDateShort = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("fr-FR");
};

/**
 * Formate une date avec l'heure
 * @param {string|Date} dateString - La date à formater
 * @returns {string} La date formatée avec l'heure
 */
export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString("fr-FR", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

/**
 * Formate une date pour l'affichage dans les widgets (format court)
 * @param {string|Date} dateString - La date à formater
 * @returns {string} La date formatée
 */
export const formatDateWidget = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });
};

